import React, { createContext, useContext, useEffect, ReactNode } from 'react';

interface ThemeContextType {
  theme: 'light'; // Always light mode
  toggleTheme: () => void; // No-op function for compatibility
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Always use light theme
  const theme: 'light' = 'light';

  useEffect(() => {
    // Always set light theme on document
    document.documentElement.setAttribute('data-theme', 'light');
    // Clean up old theme from localStorage
    localStorage.removeItem('theme');
  }, []);

  // No-op function for compatibility
  const toggleTheme = () => {
    // Do nothing - always stay in light mode
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};